/**
 * Do not edit directly
 */

export default "PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAxNCAxNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTEyLjI0OTkgMTAuMjQ2M0w2Ljk5OTkxIDQuOTk2MjVMMS43NDk5MSAxMC4yNDYzTDEuMTI4NjYgOS42MjVMNi45OTk5MSAzLjc1Mzc1TDEyLjg3MTIgOS42MjVMMTIuMjQ5OSAxMC4yNDYzWiIgZmlsbD0iYmxhY2siLz48L3N2Zz4=";